import styled from "styled-components";

export const Title = styled.div`
  width: calc(100% - 15px);
  line-height: 10px;
`;
